/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import styled from 'styled-components/native';

import Icons from './../../assets/icons';
import { getScaledValue } from '../../ui/styled';

// import {
//     getScaledValue
// } from 'renative';

export const SideItem = styled.TouchableHighlight.attrs({})`
  width: ${getScaledValue(170)}px;
  height: ${getScaledValue(70)}px;
  background: #35245d;
  margin-bottom: ${getScaledValue(12)}px;
  flex-direction: row;
  align-items: center;
  border-radius: ${getScaledValue(6)}px;
  ${(props: { active?: boolean; theme: { primary: string } }) =>
    props.active
      ? `
        border-width: ${getScaledValue(3)}px;
        border-color: ${props.theme.primary};
        box-shadow: 0px 1px 3px ${props.theme.primary};
    `
      : ``}
`;
export const SideItemImage = styled.ImageBackground.attrs({
  resizeMode: 'cover',
  source: require('./../../assets/videos/video-13.png'),
})`
  width: ${getScaledValue(50)}px;
  ${(props: { active?: boolean; theme: { primary: string } }) =>
    props.active
      ? `
            height: ${getScaledValue(64)}px;
        `
      : `
            height: ${getScaledValue(70)}px;
        `}
  background: #fff;
`;
export const SideText = styled.Text.attrs({})`
  font-family: PTSans-Regular;
  font-size: ${getScaledValue(12)}px;
  padding: 0 ${getScaledValue(12)}px;
  color: #ffffff;
`;
